module.exports = {
    // add here all the methods, props… to share
    methods: {
        testMethod() {
            // console.log("Tracker Test Method");
        },
        logTrigger: function(widget_name, before, after, triggers){
            if (before!=after){
                /*
                 * Widget possible event list: [ Close, Dismiss, Reconsider, Continue, Triggered ]
                 * [ Triggered ] is Logic driven event
                 * [ Dismiss, Continue, Close] are Button driven events
                 * [ Reconsider ] MIX :: can be logic and button driven. Note: for non-modal widget Closed event for Widget can caused only as Reconsider
                 */
                let data = { widget_name: widget_name };
                if (after===true){ // emit data object holding trigger details
                    data.event = 'triggered';
                    data.rule = null;
                    data.conditions = null;
                    for(let rule_name in triggers[widget_name]){
                        let conditions = triggers[widget_name][rule_name];
                        if(this.$root.allTrue(conditions)){
                            data.rule = rule_name;
                            data.conditions = conditions;
                            break;
                        }
                    }
                }
                if (after===false){ 
                    /* for non modal widget if it's displayed state changed from true to false it means that user change inputs selection
                     * whiche equivalent to reconsider action/event
                     */
                    data.event = 'reconsider';
                }

                this.customCLog("", {
                    triggers: triggers,
                    data: data
                });

                this.$emit('log',data);                
            }
        }        
    },
    watch: {
        triggers: function(after, before){
            let widgetDisplay = {};
            for(let widget_name in this.widgets){
                let displayBefore = this.display(widget_name, before);
                let displayAfter = this.display(widget_name, after);
                widgetDisplay[widget_name] = {
                    widget_name: widget_name,
                    display_before: displayBefore,
                    display_after: displayAfter
                };
                this.logTrigger(widget_name, displayBefore, displayAfter, after);
            }
            
            this.customCLog("", widgetDisplay);
        }
    }
}